module.exports = __webpack_public_path__ + "img/_plus_sign.b240fd8a.svg";